import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import { get } from "lodash";
import { I18n } from "@aws-amplify/core";
import { Button, Dialog, Grid, InputAdornment, ListItemText, MenuItem, Select, TextField } from "@material-ui/core";
import Search from "@material-ui/icons/Search";
import Close from "@material-ui/icons/Close";

import { setBreadcrumb } from "../../actions/common";
import { fetchGet, fetchPatch } from "../../api/fetch";
import POReplacementRow from "./POReplacementRow.js";
import EditWarning from "../Zones/EditWarning";
import CloseIcon from "../Common/CloseIcon"

const styles = {
  mainContent: {
    width: "calc(100vw - 128px)",
    height: "calc(100vh - 148px)",
    minHeight: 0,
    margin: "24px",
    padding: "24px",
    '@media(max-width: 470px)': {
      margin: "0",
      padding: "22px",
      borderRadius: "0",
      width: "100%",
      height: "100%",
    }
  },
  scanProduct: {
    display: "flex",
    alignItems: "center",
    fontSize: "14px",
    fontWeight: "500",
    color: "#5f00a0",
    cursor: "pointer",
    "& img": {
      marginRight: "4px",
    },
  },
  dialogPaper: {
    width: "100%",
    maxHeight: "100%",
    maxWidth: "360px",
    margin: 0,
  },
  dropdownSelect: {
    height: "36px",
    width: "244px",
    marginBottom: "16px",
    border: "1px solid rgba(0,0,0,0.23)",
    borderRadius: "2px",
    paddingLeft: "8px",
    "&::before": {
      border: "none"
    },
    "& .MuiTypography-body1": {
      fontSize: "14px",
    },
    '@media(max-width: 470px)': {
      width: "290px",
    }
  },
  inputSubtitle: {
    fontSize: "14px",
    fontWeight: "500",
  },
  optional: {
    marginLeft: "4px",
    color: "rgba(0,0,0,0.54)",
    fontWeight: "normal",
  },
  searchInput: {
    width: "244px",
    height: "36px",
    marginBottom: "16px",
    fontSize: "14px",
    "&::placeholder": {
      fontStyle: "italic",
    },
    '@media(max-width: 470px)': {
      width: "290px",
    }
  },
  resultsHeader: {
    display: "flex",
    fontWeight: "500",
    margin: "8px 0px"
  },
  resultsContainer: {
    minWidth: "280px",
    maxHeight: "540px",
    overflowY: "auto",
    marginBottom: "24px",
    display: "grid",
    gridAutoFlow: "column",
    columnGap: "64px",
    gridAutoColumns: "250px",
    gridTemplateRows: "repeat(10, 1fr)",
    '@media(max-width: 470px)': {
      maxWidth: "100%",
      maxHeight: "300px",
    }
  },
  confirmBtn: {
    width: "112px",
    height: "36px",
    backgroundColor: "#5f00a0",
    borderRadius: "2px",
    border: "none",
    color: "white",
    fontWeight: "500",
    boxShadow: "0px 2px 2px #00000033",
  },
  disabledButton: {
    backgroundColor: "#dddddd",
    color: "#00000061",
    userSelect: "none",
    pointerEvents: "none",
  },
  requestButton: {
    cursor: "not-allowed",
    pointerEvents: "none",
  },
  confirmContainer: {
    width: 380,
    height: 250,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between"
  },
  confirmClose: {
    display: "flex",
    justifyContent: "flex-end",
  },
  warningMessage: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  confirmButtons: {
    paddingBottom: "32px",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  }
};

function getWidth() {
  return Math.max(
    document.body.scrollWidth,
    document.documentElement.scrollWidth,
    document.body.offsetWidth,
    document.documentElement.offsetWidth,
    document.documentElement.clientWidth
  );
}

const POReplacement = (props) => {
  const { classes, dispatch, language } = props;

  const [poCode, setPoCode] = React.useState("")
  const [poList, setPoList] = React.useState([])
  const [poReplacement, setPoReplacement] = React.useState([])
  const [poReplacementQty, setPoReplacementQty] = React.useState(0)
  // Dialog
  const [replaceDialog, setReplaceDialog] = React.useState(false)
  const [replaceDialogConfirm, setReplaceDialogConfirm] = React.useState(false)
  // Dropdown Companies
  const [company, setCompany] = React.useState()
  const [dropdownCompanies, setDropdownCompanies] = React.useState([])
  // Sending Request Status
  const [sendingRequest, setSendingRequest] = React.useState(false)

  React.useEffect(() => {
    dispatch(
      setBreadcrumb([
        {
          name: I18n.get("sidebar_po_search"),
        },
      ])
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    try {
      fetchGet(`vmi/companies/sectors/vmi`)
        .then(companies => {
          setDropdownCompanies(companies)
        })
        .catch(e => console.error(e))

    } catch (e) {
      console.log(e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGetPoList = () => {
    try {
      fetchGet(`zones/search_po/${company}${poCode ? `/${poCode}` : ""}`)
        .then(data => {
          setPoList(data.map(po => po.attribute_value))
        })
        .catch(e => console.error(e))
    } catch (e) {
      console.log(e);
    }
  }

  const handleSelection = event => {
    setCompany(event.target.value);
  };

  const handlePoReplace = poEdit => {
    if (poReplacement.map(r => r.old_value).includes(poEdit.old_value)) {
      let _poReplacement = poReplacement.filter(r => r.old_value !== poEdit.old_value);
      if (poEdit.new_value === "") {
        setPoReplacement([..._poReplacement])
      } else {
        setPoReplacement([..._poReplacement, poEdit])
      }
    } else {
      setPoReplacement([...poReplacement, poEdit])
    }
  }

  const handleSubmitPoReplace = () => {
    const body = {
      "company_id": company,
      "items": poReplacement
    }

    try {
      setSendingRequest(true)
      setPoReplacementQty(poReplacement.length)

      fetchPatch(`zones`, body)
        .then(() => {
          setSendingRequest(false)
          setPoReplacement([])
          setPoList([])
        })
        .catch(e => console.error(e))
    } catch (e) {
      console.log(e);
    }
  }

  const handleReplaceDialogConfirm = () => {
    setReplaceDialogConfirm(false);
    setTimeout(() => setPoReplacementQty(0), 1000)
  }

  return (
    <Grid
      container
      direction="column"
      wrap="nowrap"
      className={`mainContent ${classes.mainContent}`}
    >
      <Dialog open={replaceDialog}
        onClose={() => { setReplaceDialog(false) }}
      >
        <EditWarning
          language={language}
          handleNo={() => { setReplaceDialog(false); }}
          handleClose={() => { setReplaceDialog(false); }}
          message={poReplacement.length > 0 && poReplacement.length === 1 ? "replace_po_confirm_singular" : "replace_po_confirm"}
          handleRowClick={() => { handleSubmitPoReplace(); setReplaceDialog(false); setReplaceDialogConfirm(true) }}
        />
      </Dialog>
      <Dialog open={replaceDialogConfirm}
        onClose={() => handleReplaceDialogConfirm()}
      >
        <div className={classes.confirmContainer}>
          <div className={classes.confirmClose}>
            <span onClick={() => handleReplaceDialogConfirm()}>
              <CloseIcon />
            </span>
          </div>
          <div style={{ height: 0 }}>
            <span className={classes.warningMessage}>{poReplacementQty} {poReplacementQty > 1 ? I18n.get("replace_po_confirmed") : I18n.get("replace_po_confirmed_singular")}</span>
          </div>
          <div className={classes.confirmButtons}>
            <Button onClick={() => handleReplaceDialogConfirm()} color="primary">{"OK"}</Button>
          </div>
        </div>
      </Dialog>
      <div>
        <div className={classes.searchControl}>
          <div className={classes.inputSubtitle}>{I18n.get("site_company")}</div>
          <div>
            <Select
              value={company}
              onChange={handleSelection}
              MenuProps={{
                getContentAnchorEl: null,
                PaperProps: {
                  style: {
                    maxHeight: getWidth() > 478 ? 360 : 540,
                    width: getWidth() > 478 ? 244 : 190,
                    fontSize: "14px",
                  },
                },
              }}
              className={classes.dropdownSelect}
              disableUnderline={true}
            >
              {dropdownCompanies.map((c, i) =>
                <MenuItem key={`company-${i}`} value={c.id} >
                  <ListItemText primary={c.name} />
                </MenuItem>)}
            </Select>
            <button
              style={{ marginLeft: "16px" }}
              className={`${classes.confirmBtn} ${!company ? classes.disabledButton : ""} ${sendingRequest ? classes.requestButton : ""}`}  // 
              type="button"
              onClick={() => handleGetPoList()}>
              {I18n.get("site_search").toUpperCase()}
            </button>
          </div>
          <div className={classes.inputSubtitle}>{"PO"}<span className={classes.optional}>{`(${I18n.get("profiles_optional")})`}</span></div>
          <TextField
            value={poCode}
            onChange={e => setPoCode(e.target.value)}
            variant="outlined"
            InputProps={{
              startAdornment: <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)" }}><Search /></InputAdornment>,
              endAdornment: poCode ? <InputAdornment position="start" style={{ color: "rgba(0, 0, 0, 0.38)", cursor: "pointer" }} onClick={e => setPoCode("")}><Close /></InputAdornment> : null,
              className: classes.searchInput,
              style: { fontSize: 14, padding: "0 0 0 8px" }
            }}
          />
        </div>
        <div>
          <div className={classes.resultsHeader}>
            <div style={{ width: "120px" }}>{`${poList.length} PO ${I18n.get("site_found")}${language === "fr" && poList.length > 1 ? "(s)" : ""}`}</div>
            {poList.length > 0 ?
              <div style={{ width: "130px" }}>{I18n.get("replace_for")}</div>
              : null}
          </div>
          <div className={classes.resultsContainer}>
            {poList.map((r, i) =>
              <POReplacementRow key={`PO-Code-${i}`} data={r} handlePoReplace={handlePoReplace} />
            )}
          </div>
          {poList.length > 0 ?
            <button
              style={{ marginLeft: "16px" }}
              className={`${classes.confirmBtn} ${poReplacement.length === 0 ? classes.disabledButton : ""} ${sendingRequest ? classes.requestButton : ""}`}
              type="button"
              onClick={() => setReplaceDialog(true)}>
              {I18n.get("wms_replace").toUpperCase()}
            </button> : null}
        </div>
      </div>
    </Grid>
  )
}

const mapStateToProps = (state) => {
  return {
    language: get(state, ["user", "language"]),
  };
};

export default withRouter(
  connect(mapStateToProps)(withStyles(styles)(POReplacement))

);